import DealLinkWithStatus from './DealLinkWithStatus';

export default DealLinkWithStatus;
